<template>
  <q-page class="main">
    <common-form :action="$route('user.store')" >
      <q-card class="page-card">
        <q-card-section class="page-card__main-content">
          <h1 class="heading-2 q-mb-lg">Nodig een gebruiker uit</h1>

          <p>Deze gebruiker ontvangt een e-mail waarmee een account kan worden aangemaakt.</p>
          <user-form :user="user" :roles="roles" :categories="categories" is-create/>
        </q-card-section>
        <q-separator />
        <q-card-actions align="right" class="q-pa-md">
          <accent-button label="Opslaan" type="submit"/>
        </q-card-actions>
      </q-card>
      <sticky-top-bar />
    </common-form>
  </q-page>
</template>

<script>
import UserForm from './UserForm'

export default {
  components: {
    UserForm
  },
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      user: {
        role_ids: [],
        categories: []
      }
    }
  }
}
</script>
